export default __webpack_public_path__ + "media/images/apple_logo_white-61149114.svg";